var __TEMP__ = require('./_baseRest.js');var baseRest = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * A `baseRest` alias which can be replaced with `identity` by module
 * replacement plugins.
 *
 * @private
 * @type {Function}
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
var castRest = baseRest;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = castRest;
